import AgeGroupSelect from './AgeGroupSelect';
import { Form } from './';
import { formPropTypes, mapModelOptions } from './common';

import React from 'react';
import { find, get } from 'lodash';

const ContestForm = ({ formProps, values, meta, onInputChange }) => (
  <Form {...formProps}>
    <Form.Group widths="equal">
      <Form.Field
        control={AgeGroupSelect}
        name="ageGroup"
        options={meta.ageGroups}
        value={values.ageGroup}
        onChange={onInputChange}
        label="Age group"
        placeholder="Age group"
        required
        fluid
      />
      <Form.Select
        name="bodyweightCategory"
        options={mapModelOptions(
          get(
            find(meta.ageGroups, { primaryKey: values.ageGroup }),
            'bodyweightCategories',
            [],
          ),
          'title',
        )}
        value={values.bodyweightCategory}
        onChange={onInputChange}
        label="Bodyweight category"
        placeholder="Bodyweight category"
        required
        fluid
      />
    </Form.Group>
    <Form.Input
      name="title"
      value={values.title || ''}
      onChange={onInputChange}
      label="Title"
      placeholder="Title"
      required
      fluid
    />
    <Form.Input
      name="entryTotalMinimum"
      value={values.entryTotalMinimum || ''}
      onChange={onInputChange}
      label="Minimum entry total"
      placeholder="Minimum entry total"
      fluid
    />
  </Form>
);

ContestForm.propTypes = formPropTypes;

export default ContestForm;



// WEBPACK FOOTER //
// ./src/components/ContestForm.js